'use strict';

module.exports = {
  production: {
    username: 'root',
    hostname: 'whitewatertools.com'
  },
  development: {
    username: 'root',
    hostname: '107.170.42.192'
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/common/dist/servers.js
// module id = 2344
// module chunks = 0